export const API = {
    "sql": async function(vue,sql){
        let url = window.baseurl + `/sql`;
        var response = await vue.$http.post(url, { sql: sql });
        return response;
    },
    "sqlprep": async function(vue,sql,pars, repls){
        let url = window.baseurl + `/sqlprep`;
        var p = { sql: sql, pars: pars }
        if(repls) p.repls = repls
        var response = await vue.$http.post(url, p);
        return response;
    },
    "setPass": async function(vue, pw){
        let url = window.baseurl + `/setPass`;
        var p = { pw }
        var response = await vue.$http.post(url, p);
        return response;
    },
    "getmenu": async function(vue,lmin,lmax){
        let url = window.baseurl + '/menu';
        var response = await vue.$http.get(url)
        // console.log("RESP:",response.data)
        var main = []
        var items = []
        response.data.forEach(e => {
        if(!e.pid) {
            main[e.id] = {name: e.text, url: e.onclick, icon: "fa fa-"+e.style}
            items.push(main[e.id])
        } else {
            if(!main[e.pid].children)
            main[e.pid].children = []
            main[e.pid].children.push({name: e.text, url: e.onclick, icon: "fa fa-"+e.style})
        }
        })
        console.log("MENUITEMS:",items)
        return items
    },
    "getpars": async function(vue, sid){ // se non passo la sede, uso quella dell'utente
        let td = window.myMixin.methods.getTokenData.call(vue) // passa vue come this !
        console.log("TD",td)
        if(td && td.sub) {
            let sedeid = sid || (td.sub.user ? td.sub.user.sedeid : td.sub.guest.sedeid)
            var ps = await vue.$http.get(window.baseurl + "/getpars")
            // li ordino per sede, così in caso di assegnazione specifica vado a sovrascrivere e filtrare
            let dati = ps.data.dati.filter(d => d.sedeid==null || d.sedeid*1===sedeid).sort((a,b)=>{
                if(a.sedeid==null && b.sedeid==null) return a.nome.localeCompare(b.nome)
                else if(a.sedeid==null) return -1
                else if(b.sedeid==null) return 1
                else return a.nome.localeCompare(b.nome)
            })
            dati.map( p => {
                window[p.nome] = p.valore
                console.log("API:" + p.nome + " = " + p.valore)
            })
        }
    }
}
